import React, { useState } from 'react';
import './CreateMember.css';
import { Navigate } from 'react-router-dom';
import { SectionWrap } from '../../Components';

function CreateMember() {
    // const apiUrl = 'http://localhost/server/testServer/team.php';
    const apiUrl = 'https://www.albarede.com/server/team.php';

    const [title, setTitle] = useState('');
    const [position, setPosition] = useState('');
    const [disc, setDisc] = useState('');
    const [files, setFiles] = useState(null);
    const [email, setEmail] = useState('');
    const [redirect, setRedirect] = useState(false);

    async function createNewMember(ev) {
        ev.preventDefault();

        const data = new FormData();
        data.append('title', title);
        data.append('position', position);
        data.append('disc', disc);
        data.append('email', email);
        if (files) {
            data.append('files', files); // تغيير هنا من 'file' إلى 'files'
        }

        const response = await fetch(apiUrl, {
            method: 'POST',
            body: data,
        });

        if (response.ok) {
            const result = await response.json();
            console.log('uploads/', result.files); // تحقق من مسار الصورة في الرد
            setRedirect(true);
        } else {
            console.error('Error creating member:', await response.text());
        }
    }

    if (redirect) {
        return <Navigate to={'/team'} />;
    }

    return (
        <div className="createPost">
            <SectionWrap>
                <form className="createFormMember" onSubmit={createNewMember}>
                    <h1>إضافة إلى الفريق</h1>
                    <input
                        type="text"
                        placeholder="الاسم"
                        value={title}
                        onChange={(ev) => setTitle(ev.target.value)}
                        required
                    />
                    <input
                        type="text"
                        placeholder="الصفة"
                        value={position}
                        onChange={(ev) => setPosition(ev.target.value)}
                        required
                    />
                    <textarea
                        placeholder="ملخص الخبرات"
                        value={disc}
                        onChange={(ev) => setDisc(ev.target.value)}
                        required
                    />
                    <input
                        type="email"
                        placeholder="البريد الإلكتروني"
                        value={email}
                        onChange={(ev) => setEmail(ev.target.value)}
                        required
                    />
                    <label>اختر صورة </label>
                    <input
                        type="file"
                        name="files"
                        onChange={(ev) => setFiles(ev.target.files[0])}
                        required
                    />
                    <button type="submit" className="postBtn">إضافة</button>
                </form>
            </SectionWrap>
        </div>
    );
}

export default CreateMember;